import React, { useState, useEffect } from 'react';
import { Space, Button } from '@gr-monorepo/common/ui';
import { Plate, Title, Text, Row } from './VectorSurveyStyled';
import { ReactComponent as SurveyIcon } from './assets/survey.svg';
import { SurveyModal } from './components/SurveyModal';
import { SurveyCustomModal } from './components/surveyModalStyled';
import Modal from 'features/shared/Modal';
import { getSurveysData, setSurveysData } from '../../../surveys/SurveysStorage';
import { LogClick } from '../../../shared/ClickStream';

const surveyPrefix = 'vector_survey';
const surveyName = 'Опрос о возможностях Учи.ру для ДОУ';

export const VectorSurvey = ({ allowAutoOpenVectorSurvey }: { allowAutoOpenVectorSurvey: boolean }) => {
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);

  const surveyData = getSurveysData(surveyPrefix);
  if (surveyData.answered) {
    return null;
  }

  useEffect(() => {
    if (!surveyData.visited && !surveyData.answered && allowAutoOpenVectorSurvey) {
      setSurveysData(surveyPrefix, { visited: new Date() });
      setShowModal(true);
    }
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
    if (page >= 5) {
      setSurveysData(surveyPrefix, { visited: new Date(), answered: new Date() });
    }
    setPage(1);
  };

  return (
    <Plate>
      <Title>Пройдите опрос о возможностях Учи.ру для дошкольных образовательных учреждений</Title>
      <Space size={32} axis={'vertical'}></Space>
      <Text>
        В 2024–2025 учебном году Учи.ру реализует в муниципалитетах проект «Вектор роста», который позволяет
        воспитателям бесплатно пользоваться сервисами платформы и посещать онлайн-мероприятия для развития
        профессиональных навыков.
      </Text>
      <Space size={32} style={{ flex: 1 }} axis={'vertical'}></Space>
      <Row>
        <SurveyIcon />
      </Row>
      <Space size={32} style={{ flex: 1 }} axis={'vertical'}></Space>
      <LogClick
        eventInfo={`Опрос|${surveyName}: Пользователь открыл модалку с опросом`}
        eventType={`${surveyPrefix}_modal_opened`}
      >
        <Button color={'violet'} colorDisabled={'#DBB2FF'} style={{ width: '100%' }} onClick={() => setShowModal(true)}>
          пройти опрос
        </Button>
      </LogClick>
      {showModal && (
        <Modal
          onClose={handleCloseModal}
          customModalWindow={SurveyCustomModal}
          hideCloseButton={page === 4}
          disableCloseByClickByOverlay={page === 4}
        >
          <SurveyModal
            page={page}
            nextPage={() => setPage(page + 1)}
            surveyPrefix={surveyPrefix}
            surveyName={surveyName}
          />
        </Modal>
      )}
    </Plate>
  );
};
